import { ReactNode } from 'react';

import { Check } from 'lucide-react';

interface StepperItemProps {
  index: number;
  active?: boolean;
  done?: boolean;
  children: ReactNode;
  onClick?: () => void;
}

const StepperItem = ({
  index,
  active = false,
  done = false,
  children,
  onClick,
}: StepperItemProps) => {
  const circleClass =
    active || done
      ? 'bg-red-500 text-white border-red-500'
      : 'bg-white text-gray-600 border-gray-400';

  const labelClass =
    active || done ? 'text-red-600 font-semibold' : 'text-gray-500';

  return (
    <li
      className={`flex flex-row items-center gap-2 mr-4 ${
        onClick ? 'cursor-pointer' : ''
      }`}
      onClick={onClick}
    >
      <span
        className={`flex items-center justify-center w-6 h-6 rounded-full border text-xs ${circleClass}`}
      >
        {done ? <Check className="w-4 h-4 font-bold" /> : index + 1}
      </span>
      <span className={`text-sm ${labelClass}`}>{children}</span>
    </li>
  );
};

export default StepperItem;
